<pg-home-section-4>
  <section id="home-section-4">
    <img class="solutions-background" src={background}>
      <header>
        <h2>Soluções</h2>
      </header>

      <div class="container">
        <!-- Tab links -->
        <div class="tab">
          <a id="consorcio-tab" href="#/?section=solutions&tab=consorcio" class="tablinks">Consórcio</a>
          <a id="previdencia-tab" href="#/?section=solutions&tab=previdencia" class="tablinks">Previdência</a>
          <a id="vida-tab" href="#/?section=solutions&tab=vida" class="tablinks">Vida</a>
          <a id="saude-tab" href="#/?section=solutions&tab=saude" class="tablinks">Saúde</a>
        </div>

        <!-- Tab content -->
        <div id="consorcio" class="tab-content">

          <div class="tab-text" id="teste">
            <h2>Consórcio</h2>
            <a href="https://lp.vlgivida.com.br/fale-especialista" target="_blank" class="btn">
              FALE COM UM ESPECIALISTA
            </a>
            <p>O consórcio funciona como um tipo de investimento planejado e livre de
              juros que permite a aquisição de bens (Imóveis, Automóveis, Motos) ou um
              serviço (Construção, Reformas e etc).
              <br/>
              <br/>
              A proposta do consórcio é dividir o valor do bem desejado, permitindo que,
              ao longo de um determinado período, as pessoas de um mesmo grupo possam
              adquirir os bens que lhes interessam uma de cada vez.
              <br/>
              <br/>
              A ordem de contemplação é definida a partir de duas maneiras: por sorteio
              ou lance. No sorteio, todos concorrem em situação de igualdade. Já no lance,
              o objetivo é tentar antecipar o acesso ao valor contratado. Neste caso, se o
              lance ofertado pelo participante for o vencedor, ele garante o direito de
              utilizar o crédito.
            </p>
          </div>

          <img src={img1} alt="Um homem em ambiente de trabalho de investimentos" class="tab-img"/>
        </div>

        <div id="previdencia" class="tab-content">
          <div class="tab-text">
            <h2>Previdência</h2>
            <a href="https://lp.vlgivida.com.br/fale-especialista" target="_blank" class="btn">
              FALE COM UM ESPECIALISTA
            </a>
            <p>A previdência privada é um investimento de longo prazo
              conhecido por garantir uma aposentadoria de conforto e tranquilidade.
              Entretanto, esse tipo de investimento também pode ser uma ótima estratégia
              para quem pretende planejar o futuro de uma criança ou realizar um planejamento
              sucessório, devido ao fato de o patrimônio acumulado não entrar em inventário e
              o beneficiário indicado pelo titular do plano poder ter acesso rápido ao montante.
              <br/>
              <br/>
              As vantagens apresentadas pela previdência privada são importantes também para
              quem tem outros objetivos de longo prazo como: garantir os custos da faculdade dos
              filhos ou estudos no exterior. Outra vantagem desse tipo de investimento é que o
              perfil da carteira pode ser atualizado de acordo com o cenário e há a flexibilidade
              na forma de resgate do capital acumulado: em forma de renda ou resgates programados.
            </p>
          </div>

          <img src={img2} alt="Um homem de idade avançada dando um beijo na bochecha de uma mulher." class="tab-img"/>
        </div>

        <div id="vida" class="tab-content">
          <div class="tab-text">
            <h2>Vida</h2>
            <a href="https://lp.vlgivida.com.br/fale-especialista" target="_blank" class="btn">
              FALE COM UM ESPECIALISTA
            </a>
            <p>O seguro de vida visa garantir a proteção do patrimônio e
              segurança familiar diante de imprevistos. Assim, caso ocorra uma situação inesperada,
              o padrão e a qualidade de vida podem ser assegurados.
              <br/>
              <br/>
              As coberturas variam de acordo com a necessidade de cada pessoa, deste modo, o
              seguro de vida não se resume apenas a casos de ausência do segurado, mas também para
              coberturas em vida como: invalidez por doença ou por acidente, doenças graves,
              incapacidade temporária, entre outros. Em casos de perda do segurado, o(s) beneficiário(s) tem direito a receber integralmente o valor da cobertura contratada, ficando livres para utilizarem o recurso da maneira que considerarem melhor.
              <br/>
              <br/>
              A contratação de um seguro de vida é uma solução importante para quem busca por
              segurança  mesmo em momentos mais delicados.
            </p>
          </div>

          <img src={img3} alt="Uma equipe de profissionais da saúde" class="tab-img"/>
        </div>

        <div id="saude" class="tab-content">
          <div class="tab-text">
            <h2>Saúde</h2>
            <a href="https://lp.vlgivida.com.br/fale-especialista" target="_blank" class="btn">
              FALE COM UM ESPECIALISTA
            </a>
            <p>A garantia de saúde dos trabalhadores é um fator de
              extrema importância para uma empresa. A valorização do bem estar do
              colaborador proporciona benefícios a ele e à própria instituição.
              <br/>
              <br/>
              O plano de saúde assegura um acesso mais fácil a exames, consultas e
              acompanhamento do bem-estar, além de de ser uma fonte de motivação ao
              trabalhador dentro da empresa, tendo em vista que ele possui garantia de
              coberturas para quando precisar.
            </p>
          </div>

          <img src={img4} alt="Uma família de 1 casal e um bebê assistindo algo em um celular, sorrindo" class="tab-img"/>
        </div>

      </div>
  </section>

  <script>
    import './pg-home-section-4.scss'

    import background from '../../media/Grupo 134.svg';
    import img1 from '../../media/consorcio-img.jpg'
    import img2 from '../../media/previdencia.jpg'
    import img3 from '../../media/plano de saude.jpg'
    import img4 from '../../media/Seguro de vida.jpg'
    export default {
      background,
      img1,
      img2,
      img3,
      img4,
      openTab(tabName) {
        // Declare all variables
        var i, tabcontent, tablinks;

        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("tab-content");

        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
        }

        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        this.$(`#${tabName}`).style.display = "grid"
        this.$(`#${tabName}-tab`).classList.add('active')
      },
      onMounted(props){
        if(props.route.query.tab) {
          setTimeout(()=>{
            this.openTab(props.route.query.tab)
          },0)
        } else {
          this.openTab("consorcio")
        }
      },
      onUpdated(props){
        if(props.route.query.tab) {
          setTimeout(()=>{
            this.openTab(props.route.query.tab)
          },0)
        }
      },


    }
  </script>
</pg-home-section-4>
